// extracted by mini-css-extract-plugin
module.exports = {"width-input":"i_D3","inputs":"i_D4"};